import { useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import styled from 'styled-components';
import PluvaMarketLogo from '../../../../assets/images/pvm_logo_192x192.png';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { globalTooltipSlice } from '../../../../store/globalTooltip';
import { getAppURL } from '../../../../utils/getter/getAppURL.util';
import { Icon } from '../../../common/icon/Icon';

export const DownloadAppModal = () => {
  const dispatch = useAppDispatch();
  const globalTooltipStates = useAppSelector((state) => state.globalTooltip);
  const globalTooltipActions = globalTooltipSlice.actions;

  useEffect(() => {
    if (!window.ReactNativeWebView && (isIOS || isAndroid)) {
      dispatch(globalTooltipActions.showDownloadAppModal());
    } else {
      dispatch(globalTooltipActions.closeDownloadAppModal());
    }
  }, [isIOS, isAndroid, dispatch, globalTooltipActions]);

  const handleDownloadButtonClick = () => {
    window.location.href = getAppURL()!;
  };

  if (globalTooltipStates.isShowAnyTooltip && globalTooltipStates.isShowDownloadAppModal) {
    return (
      <Container>
        <CloseButton
          onClick={() => {
            dispatch(globalTooltipActions.closeDownloadAppModal());
          }}
        >
          <Icon name={'CloseGreyBold'} width={16} height={16} />
        </CloseButton>
        <LogoWrapper>
          <LogoImage src={PluvaMarketLogo} />
        </LogoWrapper>
        <TextConatiner>
          <Title>{'신뢰할 수 있는 중고 트랙터 플랫폼'}</Title>
          <Description>{'플루바 마켓'}</Description>
        </TextConatiner>
        <DownloadButton onClick={handleDownloadButtonClick}>{'설치하기'}</DownloadButton>
      </Container>
    );
  }
  return <></>;
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 74px;

  background-color: #232429;
`;

const CloseButton = styled.button`
  height: 100%;
  padding: 0px 16px;
`;

const TextConatiner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  flex-grow: 1;

  padding: 9px 16px;
`;

const Title = styled.h2`
  color: #fff;

  font-size: 14px;
  font-weight: 700;
  line-height: 14px;

  margin-bottom: 2px;

  white-space: nowrap;
`;

const Description = styled.h3`
  color: #fff;

  font-size: 14px;
  line-height: 14px;
`;

const DownloadButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 64px;
  height: 100%;

  background-color: #445eff;

  font-size: 12px;
  font-weight: 700;
  line-height: 12px;

  color: #fff;
`;

const LogoWrapper = styled.div`
  min-width: 48px;
  max-width: 48px;
  min-height: 48px;
  max-height: 48px;
  position: relative;
`;

const LogoImage = styled.img`
  width: 100%;
  height: 100%;

  top: 0;
  left: 0;

  position: absolute;

  border-radius: 8px;
`;
